import React, {Fragment, useEffect, useRef, useState} from "react";
import ReactApexChart from 'react-apexcharts';
// import moment from 'moment';
import 'moment/locale/pl'

const BoxPlot = ({displayData, loading, name,title,value_type, start, end}) => {
     const valueConvert = (val, prec = 2) => {
        if (typeof val === typeof 1){
            if(val >-5 && val <= 5)
                prec =2;
            if((val <-5 && val <= -10) || (val >5 && val <=10))
                prec =1;
            if(val <-10 || val > 10)
                prec =0;
            return (Number(val).toFixed(prec)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",") +value_type

        }

        return val + value_type
    }
    const [series, setSeries] = useState([])
     const [scaleData, setScale] = useState({
        nazwa_regionu: {
            sync: true,
        },
        "range": {

            max: 10,
            min: -10,
            nice: "true"
        },
        "wartosc_wskaznika":{
            max: 10,
            min: -10,
                }
    });
    const scaleCharts = (data) => {
        let valuesMAXArray = data.map(item => item.high);
        let valuesMINArray = data.map(item => item.low);
        if (valuesMAXArray.length !== 0) {
            setScale({
                nazwa_regionu: {
                    sync: true
                },
                "range": {
                    min: valuesMINArray.reduce((prev, curr) => prev < curr ? prev : curr)*1.1,
                    max: valuesMAXArray.reduce((prev, curr) => prev > curr ? prev : curr)*1.1,

                },
                "wartosc_wskaznika":{
                    min: valuesMINArray.reduce((prev, curr) => prev < curr ? prev : curr)*1.1,
                    max: valuesMAXArray.reduce((prev, curr) => prev > curr ? prev : curr)*1.1,
                    alias: "Wartość wskaźnika dla twojego szpitala",
                }
            })
        }
    };
    useEffect(() => {
        if (displayData) {
            scaleCharts(displayData);
            setSeries(() => {
                const boxplot = []
                const line = []
                displayData.map(dataItem => {
                    boxplot.push(
                        {
                            x: dataItem.nazwa_regionu,
                            y: [dataItem.low.toFixed(2), dataItem.q1.toFixed(2), dataItem.median.toFixed(2), dataItem.q3.toFixed(2), dataItem.high.toFixed(2)]
                        }
                    )
                })

                displayData.map(dataItem => {
                    line.push(
                        {
                            x: dataItem.nazwa_regionu,
                            y: dataItem.wartosc_wskaznika.toFixed(2)
                        }
                    )
                })
                return ([{
                    name: 'Wartości regionalne',
                    type: 'boxPlot',
                    data: boxplot
                },
                    {
                        name: 'Mój podmiot',
                        type: 'line',
                        data: line
                    }
                ])

            })
        }
    }, [displayData])

    if(displayData && displayData.length>0)console.log(displayData[0]['wartosc_wskaznika']);
    const displayTitle = ()=>{
        if((new Date(start).getMonth() === new Date(end).getMonth()) && (new Date(start).getFullYear()=== new Date(end).getFullYear()))
            return " za " + (new Date(start).getMonth() + 1) + "/" + new Date(start).getFullYear();

        return (start ? (" od " + (new Date(start).getMonth() + 1) + "/" + new Date(start).getFullYear()) : "") + (end ? (" do " + (new Date(end).getMonth() + 1) + "/" + new Date(end).getFullYear()) : "")
    }

    const settings = {

        options: {
            tooltip:{
                followCursor:false,
                custom: function({ series, seriesIndex, dataPointIndex, w }){
                    const val = w.globals.initialSeries[0]['data'][dataPointIndex]['y'] 
                    return ('<div style="padding: 5px; font-size:10px "><div >'+'<strong>Maksimum: </strong>'+valueConvert(Number(val[4]))+'</div><br/>'+
                    '<div><strong>'+'Q3:</strong> '+valueConvert(Number(val[3]))+'</div><br/>'+
                    '<div><strong>'+'Mediana: </strong>'+valueConvert(Number(val[2]))+'</div><br/>'+
                    '<div><strong>'+'Q1: </strong>'+valueConvert(Number(val[1]))+'</div><br/>'+
                    '<div><strong>'+'Minimum: </strong>'+valueConvert(Number(val[0]))+'</div></div>')
                }
            },
            annotations: {
                position:'front',
                yaxis: [{
                  y: displayData && displayData.length !==0 ?  displayData[0]['wartosc_wskaznika']:null,
                  borderColor: '#f9da0e',
                  fillColor: '#f9da0e',
                  strokeDashArray: 0,
                  opacity: 1,
                    width: "100%",
                  label: {
                    borderWidth: 0,
                    style: {
                      color: 'rgb(14,14,14)',
                      background: '#fff',
                      
                    },
                    text: 'Mój podmiot',
                    offsetY: -5,
                  },
                }]},
            title: {
                text: name + displayTitle(),
                align: 'center',
                margin: 10,
                offsetX: 0,
                offsetY: 0,
                floating: false,
                style: {
                    fontSize: '14px',
                    fontWeight: 600,
                    fontFamily: "Montserrat, Helvetica Neue",
                    color: '#263238'
                },
            },
                    subtitle: {
            text: title,
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 25,
            floating: false,
            style: {
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: "Montserrat, Helvetica Neue",
                color: '#263238'
            },


        },

            chart: {
                // type: 'boxPlot',
                height: 250,
                horizontal: true,
                locales: [{
                    "name": "pl",
                    "options": {
                        "toolbar": {
                            "exportToSVG": "pobierz SVG",
                            "exportToPNG": "pobierz PNG",
                            "exportToCSV": "pobierz CSV",
                        }
                    }
                }],
                animations: {
                    enabled: false,
                },

                defaultLocale: "pl",
                toolbar: {
                    offsetX: -100,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    },
                    export: {
                        csv: false,
                        png: {
                            filename: "test",
                        }
                    },
                },
            },
            stroke: {
                width: [1,5,3],
                colors: ['#000',
                    'rgb(255,211,35)',
                    // 'rgba(255, 99, 132, 1)',
                    //   'rgba(255, 69, 96, 0.85)'
                ],
                curve: 'straight',
                dashArray: 0
            },

            // markers
            markers: {
                size: 0,
                colors: ['rgba(32, 121, 147, 0.1)'],
                fillColors: ['rgba(17,17,17,0.98)'],

                hover: {
                    sizeOffset: 2
                }
            },

            // Legend
            legend: {
                show: false,
                markers: {
                    width: 12,
                    height: 12,
                    fillColors: ['rgba(32, 121, 147, 0.3)', 'rgba(255, 99, 132, 1)'],
                },

            },

            // axis: {
            yaxis: {
                max: scaleData.range.max,
                min: scaleData.range.min,
                labels:{formatter: function(val){
                          return valueConvert(val)
                      }}

            },
          xaxis: {
              position: 'bottom',
              labels: {
                  show: true,
                  rotate: -35,
                  rotateAlways: true,
                  hideOverlappingLabels: false,
                  minHeight: 100

              },
          },

            // },
            // plot Options
            plotOptions: {

                boxPlot: {
                    horizontal: true,
                    colors: {
                        upper: '#c8e4ee',
                        lower: '#6bbcd4',
                    },


                }

            }
        },
    };
    return (
        <>
            {loading && <ReactApexChart options={settings.options} series={series} type="boxPlot"/>}
             <div style={{fontSize: "12px",textAlign:"left"}}>
                          *Na wykresie zaprezentowano wartość wskaźnika dla Twojego podmiotu oraz medianę, pierwszy i trzeci kwartyl, wartości minimalne i maksymalne (z wyłączeniem obserwacji odstających) danego wskaźnika dla podmiotów w poszczególnych województwach i w Polsce.


            </div>
        </>
    )
}


export default BoxPlot
